import axios from "axios";
import React, { useState, createRef } from "react";
import { useHistory } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Geocode from "react-geocode";
import "./EditListing.scss";

export default function EditListing(props) {
  const navigate = useHistory();
  const listingData = props.data;
  console.log(listingData.imgPath);
  const { REACT_APP_SECRET_GOOGLE_API_KEY, REACT_APP_API_ENDPOINT } =
    process.env;
  Geocode.setApiKey(REACT_APP_SECRET_GOOGLE_API_KEY);
  const [address, setAddress] = useState();
  const [formatAddress, setformatAddress] = useState();
  const [userImage, setUserImage] = useState();

  const handleImage = (event) => {
    setUserImage(URL.createObjectURL(event.target.files[0]));
  };
  const searchHandler = (event) => {
    setAddress(event.target.value);
  };
  const searchSubmit = (event) => {
    event.preventDefault();
    Geocode.fromAddress(address).then(
      (res) => {
        setformatAddress(res.results[0].formatted_address);
        const { lat, lng } = res.results[0].geometry.location;
        props.setLocation({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  const imgRef = createRef();
  const handleInputs = (event) => {
    event.preventDefault();
    if (false) {
      // validations
    } else {
      const formData = new FormData();
      formData.append("name", event.target.fname.value);
      formData.append("email", event.target.email.value);
      formData.append("phone", event.target.phone.value);
      formData.append(
        "address",
        formatAddress ? formatAddress : listingData.address
      );
      formData.append("price", event.target.price.value);
      formData.append("desc", event.target.desc.value);
      formData.append("lat", props.currentLocation.lat);
      formData.append("lng", props.currentLocation.lng);
      formData.append("image", imgRef.current.files[0]);
      axios
        .put(REACT_APP_API_ENDPOINT + "/" + props.data.id, formData, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          navigate.push("/");
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className="EditListings">
      <div className="EditListing__form form-group">
        <div className="EditListing__search-wrap">
          <Form>
            <Form.Label className="EditListing__search-input-label">
              <Form.Control
                onChange={searchHandler}
                type="search"
                autoComplete="off"
                placeholder="Type in your address here..."
                className="EditListing__search mb-3"
                defaultValue={listingData.address}
              ></Form.Control>
              <Button
                variant="secondary"
                type="submit"
                className="EditListing__add-button"
                onClick={searchSubmit}
              >
                search
              </Button>
            </Form.Label>
          </Form>
        </div>
        <div className="EditListing__content">
          <div className="EditListing__client-pop-up">
            <img
              src={userImage ? userImage : listingData.imgPath}
              className="EditListing__client-image"
              alt="Client"
            />{" "}
            <Form.Label>Preview</Form.Label>
          </div>
          <div className="EditListing__location-data"></div>
          <Form onSubmit={handleInputs}>
            <Form.Group controlId="formFile" className="mb-3">
              <div className="EditListing__fields">
                <Form.Label>Upload An Image:</Form.Label>
                <Form.Control
                  type="file"
                  className="EditListing__input"
                  name="image"
                  ref={imgRef}
                  onChange={handleImage}
                />
              </div>
              <div className="EditListing__flex-wrap">
                <div className="EditListing__fields EditListing__half--left">
                  <Form.Label>Full Name:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Please enter your full name. "
                    className="EditListing__input"
                    name="fname"
                    defaultValue={listingData.name}
                  />
                </div>
                <div className="EditListing__fields EditListing__half--right">
                  <Form.Label>Address:</Form.Label>
                  <Form.Control
                    type="text"
                    className="EditListing__input"
                    name="address"
                    placeholder={
                      listingData.address
                        ? listingData.address
                        : "Please type in your address above and press search."
                    }
                    readOnly
                  />
                </div>
              </div>
              <div className="EditListing__flex-wrap EditListing__fields">
                <div className="EditListing__half--left">
                  <Form.Label>Phone No.:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Please enter your phone #"
                    name="phone"
                    defaultValue={listingData.phone}
                    className="EditListing__input"
                  />
                </div>
                <div className="EditListing__half--right">
                  <Form.Label>Email Address:</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    defaultValue={listingData.email}
                    placeholder="name@example.com"
                    className="EditListing__input"
                  />
                </div>
              </div>
              <div className="EditListing__flex-wrap">
                <div className="EditListing__fields EditListing__half--left">
                  <Form.Label>Price:</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={listingData.price}
                    placeholder="Please enter the monthly rent price."
                    name="price"
                    className="EditListing__input"
                  />
                </div>
                <div className="EditListing__fields EditListing__half--right">
                  <Form.Label>Description:</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Please enter the number of bedrooms and bathrooms"
                    name="desc"
                    defaultValue={listingData.desc}
                    className="EditListing__input"
                  />
                </div>
              </div>

              <Button
                type="submit"
                variant="primary"
                className="EditListing__submit-button"
              >
                Submit
              </Button>
            </Form.Group>
          </Form>
        </div>
      </div>
    </div>
  );
}
